import request from '@/utils/request' //引入封装好的 axios 请求

//一键授信产品
export function dedicatedList0(data = {}) {
    return request({
        url: '/api/credit/dedicated/dedicatedList?type=0',
        method: 'post',
        data: data
    })
}
//小微企业
export function dedicatedList1(data = {}) {
    return request({
        url: '/api/credit/dedicated/dedicatedList?type=1',
        method: 'post',
        data: data
    })
}
//个体工商户
export function dedicatedList2(data = {}) {
    return request({
        url: '/api/credit/dedicated/dedicatedList?type=2',
        method: 'post',
        data: data
    })
}
//科技、医疗及进出口企业
export function dedicatedList3(data = {}) {
    return request({
        url: '/api/credit/dedicated/dedicatedList?type=3',
        method: 'post',
        data: data
    })
}
// 查看优惠券
export function getCouponList(data = {}) {
    return request({
        url: '/api/credit/coupon/getCouponList',
        method: "post",
        data: data
    })
}
// 获取累积放贷金额
export function dedicatedCount(data = {}) {
    return request({
        url: '/api/credit/dedicated/dedicatedCount ',
        method: "post",
        data: data
    })
}
